__turbopack_context__.v({
  "di": "dietary-indicators-module__YCLHpq__di",
  "diCard": "dietary-indicators-module__YCLHpq__diCard",
  "diHero": "dietary-indicators-module__YCLHpq__diHero",
  "diMore": "dietary-indicators-module__YCLHpq__diMore",
  "diText": "dietary-indicators-module__YCLHpq__diText",
  "hashi": "dietary-indicators-module__YCLHpq__hashi",
  "hashiArc": "dietary-indicators-module__YCLHpq__hashiArc",
  "hashiCore": "dietary-indicators-module__YCLHpq__hashiCore",
  "hashiLabelled": "dietary-indicators-module__YCLHpq__hashiLabelled",
  "hashiRing": "dietary-indicators-module__YCLHpq__hashiRing",
  "hashiText": "dietary-indicators-module__YCLHpq__hashiText",
  "hashiTrack": "dietary-indicators-module__YCLHpq__hashiTrack",
  "row": "dietary-indicators-module__YCLHpq__row",
  "rowCard": "dietary-indicators-module__YCLHpq__rowCard",
  "rowHero": "dietary-indicators-module__YCLHpq__rowHero",
  "tip": "dietary-indicators-module__YCLHpq__tip",
});
